import { ReactNode, useEffect } from 'react';
import { useRouteError } from 'react-router-dom';
import { ConfigService } from 'app/config/config.service';
import { Box } from '@mui/material';
import { isAxiosError } from 'axios';
import { RedirectMessage } from 'app/agriculture/FarmMain/RedirectMessage';
import { Button } from '../components/Button/Button';
import { setTokenDevMode } from '../contexts/RequiredStartupProviders/TokenContext/getToken';
import * as Sentry from '@sentry/react';
import { ErrorPage } from '../routes/ErrorPage';
import { FarmNotFoundPage } from './FarmNotFoundPage/FarmNotFoundPage';

export function SuperBasicWhiteBox({ children }: { children: ReactNode }) {
    return <Box sx={{ backgroundColor: 'white' }}>{children}</Box>;
}

function useRouteActualError() {
    const error = useRouteError();
    if (!(error instanceof Error)) throw new Error('Unknown');
    return error;
}

function authRedirect() {
    window.location.href = `${ConfigService.apiUrlRoot}oidc/authenticate/`;
}

export function RootErrorElement() {
    const error = useRouteActualError();

    //More info can be found here: https://docs.sentry.io/platforms/javascript/guides/react/features/react-router/v6/
    useEffect(() => {
        Sentry.captureException(error);
    }, [error]);

    if (
        isAxiosError(error) &&
        ((ConfigService.devMode && error.status == 401) ||
            (!ConfigService.devMode && error.status == 403))
    ) {
        authRedirect();

        return <RedirectMessage />;
    }

    if (ConfigService.devMode && error.message === 'NO TOKEN') {
        return (
            <SuperBasicWhiteBox>
                Hi, please add an auth token to your local storage &#34;ls.currentApiToken&#34;
                <br />
                <a href={`${ConfigService.apiUrlRoot}oidc/authenticate/`}>Login</a>
                <br />
                <a href={`${ConfigService.apiUrlRoot}auth/api-token-auth/`}>View Token</a>
                <br />
                <label>
                    <Button
                        text={'Get and set token'}
                        onClick={async () => {
                            await setTokenDevMode();
                            location.reload();
                        }}
                    />
                </label>
            </SuperBasicWhiteBox>
        );
    }
    // We discussed for purposes of showing the users something, treating no farms and farm not found the same is ok
    if (error.message === 'FARM NOT FOUND' || error.message === 'NO FARMS') {
        return <FarmNotFoundPage />;
    }
    return <ErrorPage />;
}
